import React from 'react'

import Registrations from '../Components/Registrations'


const About = () => {



  return (
    <>
      <div className="inner-page-banner-area" style={{ backgroundImage: 'url("/images/About_images/about_banner.jpg")' }}>
        <div className="container">
          <div className="pagination-area">
            <h1>About us</h1>

          </div>
        </div>
      </div>
      <Registrations />
      <div className='container'>
        <h3 className='text'>About ITT Council, Delhi</h3>

        <p style={{ textAlign: 'justify' }}>

          ITT COUNCIL, Delhi is a registered under Government of India, working in the field of Appointing vocational trainings Center related to Computers, Accounting, Technical Education and Entrepreneurship Development. Provide Education in Information and Technical Education and its related activity in India and out of India Also ITT COUNCIL, Delhi Take Online and offline Examination and provide Diploma, Short Term, Long Term, Courses and Degrees for Completion of IT and Technical Education and establish Education Campus. ITT COUNCIL, Delhi has taken up the initiative to promote local entrepreneurs to set up institute for providing vocational trainings to the students for their skill development.
          <br /><br />

          Great philosopher & scientist of all time <b>Albert Einstein</b> once said <b>"Imagination is more important than knowledge, knowledge is limited, imagination encircles the world"</b>. These words of great visionary inspired us to start our board Information Technology and Technical Education Council, Delhi (ITT COUNCIL, Delhi) Registration under Government of India with CIN - U74999DL2016NPL299102. The top management of ITT COUNCIL, Delhi continuously strives for providing new opportunities to its centers as well to its students. Keeping pace with fast changing education and economic scenario as well as the market demand.
          <br /><br />

          <b>POLICIES TOWARDS QUALITY</b><br />
          We at our end are very particular and sincere about the policies towards quality of our overall system. Be it about the quality education or about the continuous support to our valuable franchisee partners it matters us a lot. We have very clear cut policies and guidelines for keeping up-to-date to our standards and level of study programs without any compromise. As far as our study programs and material are concerned we have Zero tolerance policy.
          <br /><br />

          Empowering students with the skills they need to thrive in today's job market, ITT Council, Delhi is a Government of India registered organization with a proven track record of success. Since 2016, we've partnered with authorized training centers across India and beyond to deliver high-quality vocational courses in Information Technology, Accounting, Technical Education, and Entrepreneurship Development.
          <br /><br />

          <b>Our Focus: Your Success</b><br />
          We believe in providing students with the knowledge and practical skills they need to land their dream jobs. Our curriculum is constantly evolving to keep pace with industry demands, ensuring students graduate with job-ready qualifications.
          <br /><br />

          • Diverse Course Offerings: Choose from a comprehensive range of Diploma, Short Term, Long Term, and Degree programs in AI, IT, Accounting, Technical fields, and more.<br />
          • Experienced Instructors: Our authorized training centers are staffed by qualified professionals who are passionate about knowledge transfer.<br />
          • Quality Education: We are committed to providing a high-quality learning experience. Our curriculum has been awarded the prestigious ISO 9001:2015 International Quality certificate, guaranteeing a rigorous and effective learning experience.
          <br /><br />

          <b>More Than Just Education</b><br />
          ITT Council is dedicated to supporting both students and authorized training centers. We offer our partners:
          <br /><br />

          • Comprehensive Support: We provide ongoing guidance, resources, and marketing assistance to ensure their success.<br />
          • Up-to-Date Curriculum: Our curriculum is constantly updated to reflect the latest industry trends and technologies.<br />
          • Networking Opportunities: Become part of a growing network of training centers, fostering collaboration and knowledge sharing.
          <br /><br />

          <b>Join Us on the Path to Success</b><br />
          Whether you're a student seeking a rewarding career or a training center looking to expand your offerings, ITT Council is here to help you achieve your goals. Contact us today to learn more about how we can partner with you!
          <br /><br />

          <b>Vision and Mission:</b><br /><br />

          • To be a leading force in empowering individuals and institutions through exceptional IT, technical education, and entrepreneurship programs, fostering a skilled and prepared workforce for the global marketplace.<br />
          • Become a recognized leader in the field of vocational training.<br />
          • Empower individuals by equipping them with job-ready skills.<br />
          • Empower institutions by providing them with the resources to deliver quality education.<br />
          • Offer exceptional programs that are relevant to industry needs.<br />
          • Prepare students for the global marketplace by fostering a skilled workforce.<br />
          • Focus on education: Providing high-quality programs.<br />
          • Industry relevance: Ensing skills align with current market needs.<br />
          • Collaboration: Working with authorized training centers.<br />
          • Student empowerment: Equipping individuals with job-ready skills.<br />
          • Institutional support: Enabling institutions to deliver exceptional education.
          <br /><br />

          To provide high-quality, industry-relevant AI, IT, technical education, and entrepreneurship programs through a network of authorized training centers, empowering individuals to develop job-ready skills and institutions to deliver exceptional education.
        </p>

        <h2 className="title-center" style={{ padding: '20px 0px' }}>
          Why Choose ITT Council, Delhi?
        </h2>

        <div className="pb-3" style={{ textAlign: 'justify' }}>

          <p>
            <b>1. Government Recognized & Certified Quality</b><br />
            Registered Institution: A Government of India registered organization (CIN: U74999DL2016NPL299102) established in 2016.<br />
            Global Standards: Awarded the ISO 9001:2015 International Quality Certificate, ensuring a rigorous and effective learning environment.
          </p>

          <p>
            <b>2. Industry-Driven Curriculum</b><br />
            Job-Ready Skills: Courses are specifically designed to bridge the gap between academic knowledge and market demand.<br />
            Future-Focused: Regular curriculum updates to include cutting-edge fields like Artificial Intelligence (AI), modern Accounting, and Technical Education.<br />
            Diverse Options: Offers a wide range of programs including Short-term, Long-term, Diplomas, and Degrees.
          </p>

          <p>
            <b>3. Robust Support for Partners (Franchisees)</b><br />
            Entrepreneurial Focus: Promotes local growth by helping entrepreneurs set up vocational training centers.<br />
            Comprehensive Assistance: Provides ongoing guidance, marketing resources, and administrative support to ensure the success of authorized centers.<br />
            Zero Tolerance Policy: Maintains a strict quality control policy for study materials and program delivery across all locations.
          </p>

          <p>
            <b>4. Flexible Examination & Learning</b><br />
            Accessibility: Conducts both Online and Offline Examinations to provide flexibility for students across different regions.<br />
            Global Reach: While headquartered in Delhi, the Council operates through a vast network of training centers both within India and internationally.
          </p>

          <p>
            <b>5. Commitment to Visionary Education</b><br />
            Inspirational Learning: Guided by the philosophy that "Imagination is more important than knowledge," fostering an environment where students learn to innovate, not just memorize.<br />
            Holistic Development: Focuses on entrepreneurship development alongside technical skills, preparing students for the global marketplace.
          </p>

        </div>
      </div>

    </>
  )
}

export default About